import { FC } from 'react';
import { Box } from '@mui/material';

const GoogleTranslateElement: FC = () => (
  <Box
    id="google_translate_element_hidden"
    sx={{ display: 'none', position: 'absolute', visibility: 'hidden' }}
  />
);

export default GoogleTranslateElement;
